export default __webpack_public_path__ + "static/media/dwg.43ed3f05.svg";